import React from "react";

function ComplaintRejectedIcon() {
  return (
    <svg width="90" height="90" viewBox="0 0 90 90" fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle cx="45" cy="45" r="45" fill="#FF0000" fillOpacity="0.2" />
      <circle cx="45.0008" cy="45.0003" r="32.1429" fill="#F44336" fillOpacity="0.1" />
      <path d="M53 38L37 53M37 38L53 53" stroke="#FF3C3C" strokeWidth="2.25" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M53 38L37 53M37 38L53 53" stroke="black" strokeOpacity="0.2" strokeWidth="2.25" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
}

export default ComplaintRejectedIcon;
